import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "details",
  initialState: {
    profile_pic: null,
    first_name: null,
    last_name: null,
    username: null,
    bio: null,
    phone_number: null,
    email: null,
    organization: null,
    points: null,
    level: null,
    last_active: null,
    twitter_url: null,
    github_url: null,
    linkedin_url: null,
    rank: null,
  },
  reducers: {
    getUserInfo: (state, action) => {
      const {
        first_name,
        last_name,
        username,
        bio,
        phone_number,
        email,
        organization,
        org_id,
        points,
        level,
        profile_pic,
        created_at,
        last_active,
        twitter_url,
        github_url,
        linkedin_url,
        rank,
      } = action.payload.userInfo;
      state.first_name = first_name;
      state.last_name = last_name;
      state.username = username;
      state.phone_number = phone_number;
      state.organization = organization;
      state.org_id = org_id;
      state.points = points;
      state.bio = bio;
      state.level = level;
      state.email = email;
      state.profile_pic = profile_pic;
      state.last_active = last_active;
      state.created_at = created_at;
      state.twitter_url = twitter_url;
      state.github_url = github_url;
      state.linkedin_url = linkedin_url;
      state.rank = rank;
    },
  },
});

export const { getUserInfo } = userSlice.actions;

export default userSlice.reducer;
